import { Link } from "react-router-dom";

/* Compliance footer rendered on the Landing page and every legal route. */
export default function LegalFooter() {
  return (
    <footer className="relative z-10 mt-16 border-t border-white/10 bg-black/50 backdrop-blur-sm" data-testid="legal-footer">
      <div className="max-w-6xl mx-auto px-6 py-6 md:py-8 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
        <div>© 2026 Tainapp Inc. All rights reserved.</div>
        <nav className="flex flex-wrap gap-x-3 gap-y-1 justify-center">
          <Link data-testid="footer-terms" to="/legal?tab=terms" className="hover:text-white">Terms of Service</Link>
          <span className="opacity-40">|</span>
          <Link data-testid="footer-privacy" to="/legal?tab=privacy" className="hover:text-white">Privacy Policy</Link>
          <span className="opacity-40">|</span>
          <Link data-testid="footer-community" to="/legal?tab=community" className="hover:text-white">Community Guidelines</Link>
          <span className="opacity-40">|</span>
          <Link data-testid="footer-disclaimer" to="/legal?tab=disclaimer" className="hover:text-white">Disclaimer</Link>
          <span className="opacity-40">|</span>
          <Link data-testid="footer-contact" to="/legal?tab=contact" className="hover:text-white">Contact &amp; Support</Link>
        </nav>
      </div>
    </footer>
  );
}
